export const statusEnum = [
    "TRANSACAO INICIADA",
    "AGUARDANDO PAGAMENTO",
    "",
    "EM ANALISE",
    "EXPIRADA",
    "AUTORIZADA",
    "CONFIRMADA",
    "NEGADA",
    "CANCELAMENTO EM ANDAMENTO",
    "CANCELADA",
    "PENDENTE DE CONFIRMACAO",
    "FALHA NA COMUNICACAO COM FORNECEDOR",
    "INTENCAO CANCELADA"
];